import styled from "@emotion/styled";

export const Form = styled.form`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-direction: column;

  @media (min-width: ${prop => prop.theme.screenSizes.mdMax}) {
    flex-direction: row;
  }
`;

export const WrapperTable = styled.div`
  position: relative;

  margin-top: 24px;
  max-height: 600px;
  overflow-y: auto;
`;
